import { Component, OnDestroy, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { SiaActionsService } from '@sia/actions';
import { SiaNewRouterService, SiaSessionService } from '@sia/shared';
import { Subscription } from 'rxjs';
import { SiaGoogleAuthDialogComponent } from '../../dialogs/sia-google-auth-dialog/sia-google-auth-dialog.component';
import { GoogleAuthService } from '../../services/google-auth.service';

declare var google: any;

@Component({
  selector: 'sia-google-user-auth',
  templateUrl: './sia-google-user-auth.component.html',
  styleUrls: ['./sia-google-user-auth.component.scss'],
  standalone: true,
  imports: [MatProgressSpinner],
})
export class SiaGoogleUserAuthComponent implements OnDestroy {
  private actionService = inject(SiaActionsService);
  private googleAuthService = inject(GoogleAuthService);
  private sessionService = inject(SiaSessionService);
  private dialog = inject(MatDialog);
  private routerService = inject(SiaNewRouterService);

  private _subs: Subscription[] = [];
  logging: boolean = false;
  ngOnDestroy() {
    this._subs?.forEach((sub) => {
      sub.unsubscribe();
    });
    this._subs = [];
  }

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {
    let s0 = this.actionService.googleUserAuthSubject$.subscribe(
      async (show: boolean) => {
        this.dialog.open(SiaGoogleAuthDialogComponent);
      },
    );
    this._subs.push(s0);
  }
}
